import { render, staticRenderFns } from "./AdministrativeCenter.vue?vue&type=template&id=ba607012&scoped=true"
import script from "./AdministrativeCenter.vue?vue&type=script&lang=js"
export * from "./AdministrativeCenter.vue?vue&type=script&lang=js"
import style0 from "./AdministrativeCenter.vue?vue&type=style&index=0&id=ba607012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba607012",
  null
  
)

export default component.exports